<template>
  <sys-data-table
    :height="altura_janela - 213"
    :item-height="45"
    :headers="cabecalhos"
    class="elevation-2"
    :items="listas_separacao"
  >
    <template #top>
      <div class="d-flex align-center pt-2 pb-1 w-full">
        <div class="d-flex align-center">
          <v-icon :size="22">mdi-format-list-bulleted</v-icon>
          <span class="font-16 font-weight-medium ml-1">Listas</span>
        </div>

        <v-spacer />

        <Novo @update:lista-separacao="buscarListaSeparacao" />
      </div>
    </template>

    <template #item.filiais_destino="{ item }">
      <ResumoFiltro :valores="item.filtros.filiais_destino" />
    </template>

    <template #item.segmentos="{ item }">
      <ResumoFiltro :valores="item.filtros.segmentos" />
    </template>

    <template #item.secoes="{ item }">
      <ResumoFiltro :valores="item.filtros.secoes" />
    </template>

    <template #item.categorias="{ item }">
      <ResumoFiltro :valores="item.filtros.categorias" />
    </template>

    <template #item.fornecedores="{ item }">
      <ResumoFiltro :valores="item.filtros.fornecedores" />
    </template>

    <template #item.produtos="{ item }">
      <ResumoFiltro :valores="item.filtros.produtos" />
    </template>

    <template #item.status_produto="{ item }">
      <v-chip
        v-if="!item.filtros.status_produto.length"
        small
        v-text="'Tudo'"
      />

      <v-chip
        v-else
        v-for="status in item.filtros.status_produto"
        :key="status"
        small
        v-text="descricao_status_produtos[status]"
      />
    </template>

    <template #item.acoes="{ item }">
      <Novo :lista_separacao="item" @update:lista-separacao="buscarListaSeparacao">
        <template #ativador="{ callback }">
          <v-btn icon @click="callback">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </Novo>
    </template>
  </sys-data-table>
</template>

<script setup>
import {useResize} from "@/helpers/Resize";
import Novo from "@/components/drp/ListaSeparacao/Crud/Novo.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import {onMounted, ref} from "vue";
import ResumoFiltro from "@/components/drp/ListaSeparacao/Crud/ResumoFiltro.vue";

const {altura_janela} = useResize();

const cabecalhos = [
  { text: 'Nome', value: 'nome' },
  { text: 'Filiais Destino', value: 'filiais_destino' },
  { text: 'Segmentos', value: 'segmentos' },
  { text: 'Seções', value: 'secoes' },
  { text: 'Categorias', value: 'categorias' },
  { text: 'Fornecedores', value: 'fornecedores' },
  { text: 'Produtos', value: 'produtos' },
  { text: 'Status Produto', value: 'status_produto' },
  { text: 'Data Criação', value: 'created_at' },
  { text: 'Ações', value: 'acoes' },
];

const descricao_status_produtos = {
  A: 'Ativos',
  FL: 'Inativos',
};

const listas_separacao = ref([]);

onMounted(buscarListaSeparacao);

function buscarListaSeparacao() {
  api.get('drp/listas-separacao')
    .then(resposta => {
      listas_separacao.value = resposta.data.listas;
    })
    .catch(logout);
}
</script>
